var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.infosPage.id_template === undefined ? _c('div', [_c('h3', {
    staticClass: "mb-15 mt-15 w-full text-center"
  }, [_vm._v("\n    Veuillez définir un modèle de page pour ce type d'évaluation.\n  ")])]) : _c('div', {
    on: {
      "keydown": function ($event) {
        return _vm.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_vm.compareCarto ? _c('PopupCompareCarto', {
    attrs: {
      "compare-carto": _vm.compareCarto,
      "carto-to-compare": _vm.cartoToCompare,
      "history-to-display": _vm.historyToDisplay,
      "competences-cles": _vm.competencesCles,
      "history-competences-cles": _vm.historyCompetencesCles.filter(function (hist) {
        return hist.template_name == _vm.competencesCles.template_name;
      }),
      "competences-informatique": {},
      "history-competences-informatique": {},
      "competences-linguistique": {},
      "history-competences-linguistique": [],
      "competences-socio-pro": {},
      "history-competences-socio-pro": {}
    },
    on: {
      "close": _vm.closeCompare,
      "changeCompare": function (index) {
        _vm.changeCompare(index);
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('create-evaluation-popup', {
    attrs: {
      "is-opened": _vm.show_add_evaluation,
      "date-debut": _vm.form.date_debut_evaluation,
      "date-fin": _vm.form.date_fin_evaluation
    },
    on: {
      "close": function ($event) {
        _vm.show_add_evaluation = false;
      },
      "changeDateDebut": function (newValue) {
        if (_vm.form.date_fin_evaluation == '' || _vm.$verifyDates({
          debut: newValue,
          fin: _vm.form.date_fin_evaluation
        })) {
          _vm.form.date_debut_evaluation = newValue;
        } else {
          _vm.badDates();
          _vm.form.date_debut_evaluation = '';
        }
      },
      "changeDateFin": function (newValue) {
        if (_vm.form.date_debut_evaluation == '' || _vm.$verifyDates({
          debut: _vm.form.date_debut_evaluation,
          fin: newValue
        })) {
          _vm.form.date_fin_evaluation = newValue;
        } else {
          _vm.badDates();
          _vm.form.date_fin_evaluation = '';
        }
      },
      "createEvaluation": _vm.create_evaluation
    }
  }), _vm._v(" "), _c('close-evaluation-popup', {
    attrs: {
      "is-opened": _vm.confirmCloseEvaluation > -1,
      "is-step-one": _vm.confirmCloseEvaluation == 0,
      "is-step-two": _vm.confirmCloseEvaluation == 1,
      "today": _vm.today
    },
    on: {
      "close": function ($event) {
        _vm.confirmCloseEvaluation = -1;
      },
      "closeEval": _vm.close_eval
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "my-15 w-full"
  }, [_vm._v("\n    " + _vm._s(_vm.infosPage.libelle_template) + "\n  ")]), _vm._v(" "), _vm.form.date_debut_evaluation == '' || _vm.form.date_fin_evaluation == '' || _vm.form.id_ref == 0 || _vm.form.template == {} ? _c('div', [_vm.role === _vm.constants.ROLE_BENEFICIAIRE ? _c('div', {
    staticClass: "flex justify-center mb-10"
  }, [_c('change-structure-input', {
    staticClass: "w-max"
  })], 1) : _vm._e(), _vm._v(" "), _vm.$can(_vm.infosPage.name_page + '_edit', _vm.infosPass.id_pass) && (_vm.role !== _vm.constants.ROLE_BENEFICIAIRE || _vm.$freeParticulier()) ? _c('div', [_c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "AJOUTER UNE ÉVALUATION",
      "uppercase": true,
      "icon": "plus-circle",
      "type-shadow": "shadow-indigo"
    },
    on: {
      "clickAction": function ($event) {
        _vm.show_add_evaluation = true;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('illustration', {
    staticClass: "mt-15",
    attrs: {
      "name": "evaluation"
    }
  })], 1)]) : _c('div', [_c('div', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n        Il n’y a pas d’évaluation en cours\n        "), _vm.listEvaluationsNeopass.length > 0 ? _c('span', [_vm._v("\n          , vous pouvez consulter\n          "), _c('br'), _vm._v("\n          vos évaluations précédentes dans l’historique ci-dessous.\n        ")]) : _vm._e(), _vm._v("\n        .\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('illustration', {
    staticClass: "mt-15",
    attrs: {
      "name": "notAllowed"
    }
  })], 1)])]) : _c('div', {
    staticClass: "m-5 md:m-15 2xl:m-20"
  }, [_vm.role !== _vm.constants.ROLE_BENEFICIAIRE && _vm.$can(_vm.infosPage.name_page + '_edit', _vm.infosPass.id_pass) || _vm.$freeParticulier() ? _c('div', {
    staticClass: "w-full mb-15 2xl:mb-20 flex justify-center"
  }, [_c('list-action-buttons', {
    attrs: {
      "today": _vm.today,
      "libelle-template": _vm.infosPage.libelle_template,
      "can-compare-cartography": _vm.canCompare && _vm.listEvaluationsNeopass.length > 0,
      "can-compare-but-not-enough-evaluation": _vm.canCompare && _vm.listEvaluationsNeopass.length === 0
    },
    on: {
      "confirmCloseEvaluation": function ($event) {
        _vm.confirmCloseEvaluation = 0;
      },
      "displayCompareCarto": function ($event) {
        return _vm.displayCompareCarto(_vm.constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES);
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.role === _vm.constants.ROLE_BENEFICIAIRE ? _c('div', {
    staticClass: "flex justify-center mb-10"
  }, [_c('change-structure-input', {
    staticClass: "w-max"
  })], 1) : _vm._e(), _vm._v(" "), ['clea', 'ref_clea'].includes(_vm.form.type_temp) ? _c('div', {
    staticClass: "flex flex-col"
  }, [_c('drop-down-list', {
    attrs: {
      "prefix-libelle": "Domaine ",
      "current-field": _vm.currentField,
      "options": _vm.form.items,
      "libelle-key-in-options-array": "libelle"
    },
    on: {
      "chooseItem": function (num) {
        _vm.currentField = num;
      }
    }
  }), _vm._v(" "), _vm._l(_vm.form.items[_vm.currentField].skills, function (skill, index) {
    return _c('checkboxes-grid', {
      key: index,
      staticClass: "my-4 md:my-8 md:mx-10",
      attrs: {
        "title": _vm.currentField + 1 + '-' + (index + 1) + '. ' + skill.libelle,
        "list": skill.criterions.reduce(function (acc, crit) {
          var _Object$assign;
          return Object.assign({}, acc, (_Object$assign = {}, _Object$assign[crit.value] = crit.check, _Object$assign));
        }, {})
      },
      on: {
        "changeValue": function (infos) {
          // Determine the key by the libelle (because it is the only value return by the component in this event)
          var jndex = skill.criterions.reduce(function (acc, crit, num) {
            var _Object$assign2;
            return Object.assign({}, acc, (_Object$assign2 = {}, _Object$assign2[crit.value] = num, _Object$assign2));
          }, {})[infos.key];
          skill.criterions[jndex].check = infos.value;
        }
      }
    });
  })], 2) : _vm._e(), _vm._v(" "), ['multi3', 'ref_multi3'].includes(_vm.form.type_temp) ? _c('div', [_vm._l(_vm.form.template, function (domaine, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "grid grid-cols-12 mb-15"
    }, [_c('div', {
      staticClass: "col-span-full text-indigo-600 uppercase text-base font-normal"
    }, [_vm._v("\n            " + _vm._s(domaine[0].libelle) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-full grid grid-cols-12 gap-4"
    }, _vm._l(domaine, function (field, jndex) {
      return _c('div', {
        key: jndex,
        staticClass: "col-span-full",
        class: jndex == 0 ? 'display-none' : domaine.length > 2 ? 'md:col-span-4' : 'md:col-span-6'
      }, [jndex !== 0 && field.type == 'text' ? _c('input-text', {
        attrs: {
          "libelle": field.libelle,
          "value": _vm.form.items[index].criterions[jndex],
          "necessary": field.libelle !== 'Préciser'
        },
        on: {
          "input": function (newValue) {
            _vm.$set(_vm.form.items[index].criterions, jndex, newValue);
          }
        }
      }) : _vm._e(), _vm._v(" "), jndex !== 0 && field.type == 'multi' ? _c('input-select', {
        attrs: {
          "name": field.libelle.toLowerCase().replace(' ', '_').replace('\'', '') + index + jndex,
          "libelle": field.libelle,
          "datas": field.criterions,
          "necessary": true,
          "value": _vm.form.items[index].criterions[jndex]
        },
        on: {
          "input": function (newValue) {
            _vm.$set(_vm.form.items[index].criterions, jndex, newValue);
          }
        }
      }) : _vm._e(), _vm._v(" "), field.type == 'text-area' ? _c('input-text-area', {
        attrs: {
          "size": "5",
          "name": field.libelle.toLowerCase().replace(' ', '_').replace('\'', ''),
          "libelle": field.libelle,
          "necessary": field.libelle.toLowerCase() !== 'commentaire',
          "value": _vm.form.items[index].criterions[jndex]
        },
        on: {
          "input": function (newValue) {
            _vm.$set(_vm.form.items[index].criterions, jndex, newValue);
          }
        }
      }) : _vm._e()], 1);
    }), 0)])]);
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full text-indigo-600 uppercase text-base font-normal"
  }, [_vm._v("\n        Commentaire\n      ")]), _vm._v(" "), _c('input-text-area', {
    attrs: {
      "size": 5,
      "name": 'commentaire',
      "necessary": false,
      "value": _vm.form.items.filter(function (item) {
        return item.name === 'Commentaire';
      })[0].value
    },
    on: {
      "input": function (newValue) {
        _vm.form.items[_vm.form.items.length - 1].value = newValue;
      }
    }
  })], 2) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }